import type { Map as MapboxMap } from "mapbox-gl";

import { useEffect, useRef } from "react";

import type { FloorMapImage } from "./floor-map-images";

import {
	removeFloorImageLayers,
	syncFloorImageLayers,
} from "./floor-image-layers";

/** Keep Mapbox image sources in sync with the selected location's floors. */
export const useFloorImages = (
	map: MapboxMap | null,
	isMapLoaded: boolean,
	images: readonly FloorMapImage[] | undefined,
) => {
	const urlsRef = useRef<Map<string, string>>(new Map());

	useEffect(() => {
		if (!map || !isMapLoaded) return;

		urlsRef.current = syncFloorImageLayers(map, images ?? [], urlsRef.current);

		return () => {
			removeFloorImageLayers(map, urlsRef.current.keys());
			urlsRef.current = new Map();
		};
	}, [images, isMapLoaded, map]);
};
